import * as React from "react";
import { Component } from "react";
import { Field, Form, reduxForm } from "redux-form";
import { mapStateToProps } from "../../../core/utils";
import { enableAutosave } from "../../../redux/actions/general/autosave";
import Input from "../../../components/Input";
import { withRouter } from "react-router";
import { subscribe } from "react-contextual";
import Localization from "../../../helpers/Localization";

@reduxForm({
    form: "superadmin_raw_colors.edit_raw_color",
    enableReinitialize: true,
})
@withRouter
@subscribe(Localization, 'localization')
@mapStateToProps(state => ({
    superadmin: state.auth.superadmin,
}))
class EditRawColorForm extends Component {
    UNSAFE_componentWillReceiveProps() {
        enableAutosave(this.props.form);
    }

    render() {
        const { handleSubmit, superadmin, localization } = this.props;

        const application_languages = _.transform(_.filter(localization.languages, language => language.application_language == true), (languages, language) => {
            languages[language.id] = language.id == 1;

            return languages;
        }, {});

        return (
            <Form onSubmit={handleSubmit}>
                <Field disabled={!superadmin.edit_raw_color} name="name" localized={application_languages} component={Input} label="Name" />
                <Field disabled={!superadmin.edit_raw_color} name="hex" maxLength={6} component={Input} label="Hex" />
                <Field disabled={!superadmin.edit_raw_color} name="priority" component={Input} numeric label="Priority" />
            </Form>
        );
    }
}

export default EditRawColorForm;